import React, {Component} from 'react';
import {translate} from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';
import swal from 'sweetalert';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import moment from 'moment';
import {Table} from 'react-bootstrap';
import Notifications, {notify} from 'react-notify-toast';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import WaitingModal from '../../generics/WaitingModal';
import DonationsModal from './DonationsModal';
import Toolbar from '../../toolbar/index';
import SvgIcon from 'react-icons-kit';
import {search} from 'react-icons-kit/icomoon/search';
import ModalPersonSearch from '../../generics/modal_person_search';
import $ from 'jquery';
import isEmail from 'validator/lib/isEmail';

const {htmlToText} = require('html-to-text');
var Config = require('../../../config');
const genders = ["HOMBRE","MUJER"];

class Samples extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.onSave = this.onSave.bind(this);
		this.validateInput = this.validateInput.bind(this);
		this.addTest = this.addTest.bind(this);
		this.updateStateDonor = this.updateStateDonor.bind(this);
		this.onReturn = this.onReturn.bind(this);
		this.printSampleLabel = this.printSampleLabel.bind(this);
		this.donationsModal = this.donationsModal.bind(this);
		this.concatGroupRH = this.concatGroupRH.bind(this);
		this.setDonation = this.setDonation.bind(this);
		this.updateNoteId = this.updateNoteId.bind(this);
		this.setValues = this.setValues.bind(this);
		this.setSecondSample = this.setSecondSample.bind(this);
		this.person_search = this.person_search.bind(this);
		
		this.state = {
			id_sample:"",
			timestamp:"",
			day_sessions:[],
			day_session_donation:"",
			convoke_places:[],
			convoke_places_id:"",
			sample_id:"",
			sample_number:"",
			sample_list:[],
			optionsDonor:[],
			document_type:"",
			documents:[],
			document_number:"",
			sex:"",
			civil_status:"",
			civil_status_list:[],
			birthday:"",
			age:"",
			names:"",
			lastname1:"",
			lastname2:"",
			email:"",
			scholarship:"",
			job_profile:"",
			street:"",
			postal_code:"",
			state:"",
			lookup_group:"",
			lookup_rh:"",

			person_donor_id:"",
			address_id:"",
			donor_id:"",
			donor_number:"",

			table_analitical:[],
			profile_list:[],
			profile_id:"",
			civil_status_array:[],
			scholarships:[],
			jobProfiles:[],
			options:[],
			mpioSelected:"",
			mpio:"",
			states:[],

			requestedSelected:[],
	    	indice:-1,

			isLoading: false,
			time_date:"",
			disableFields:false,
			preview_print:{},

			new_type:"",

			total_hc:"",
			status_bar_color:"",
			temporality:"",
			photo:"",
			phonesAdded:[],
			total_donations:0,
			donation_selected:{},
			edition:false,
			show_finish:false,
			error_email:"",
		}
	}

	componentDidMount(){
		$(document).on('blur', '.input-date', (e)=>{
			var date = moment(e.target.value, 'DD/MM/YYYY').format('YYYY-MM-DD');
			
			if(e.target.value !== ""){
				if(date === 'Invalid date' || date === 'Fecha inválida'){
					swal('Error', 'Debes ingresar un valor válido. El campo está incompleto o contiene una fecha no válida.', 'error');

					$('#'+e.target.id).addClass('error');

					setTimeout(()=>{
						$('#'+e.target.id).val('');
						e.target.value = "";
						
						this.handleChange(e);
					}, 3500)
				}else{
					$('#'+e.target.id).removeClass('error');
				}
			}else{
				$('#'+e.target.id).removeClass('error');
			}
		});

		this.getTimeServer();		

		this.props.waiting.handleShow('Cargando...');


		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);
		    if(res.Error === "No hay impresora configurada para imprimir")
				swal('¡Error!', res.Error, 'error');
		}

		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		})

		fetch(Config.default.apiGateway.URL+'work_sessions/'+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		}).then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        	}
    	}).then(response => {
			this.setState({
		      day_sessions: response
		    });
		});
		fetch(Config.default.apiGateway.URL+'work_sessions/?option=&health_facilities_id='+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		}).then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        	}
    	}).then(response => {
			this.setState({
		      day_session_donation : response.id
		    });
		});

		fetch(Config.default.apiGateway.URL+'convoke_places?option=operatives&health_facilities_id='+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		}).then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        	}
    	}).then(response => {
			this.setState({
		      convoke_places: response
		    });
		})

		fetch(Config.default.apiGateway.URL+'analitical_test?id=0&option=list', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: "Bearer "+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
 			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.test().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({analitical_list:response});
			}
		});

		fetch(Config.default.apiGateway.URL+'sample_types', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({sample_list:response});
			}
		});		

		fetch(Config.default.apiGateway.URL+'samples/get_next_number?health_facilities_id='+sessionStorage.getItem('health_facilities_id')
			+'&sample_type=DONOR',{
			method: 'get',
			headers: new Headers({
			   	'Authorization' : 'Bearer ' + sessionStorage.getItem("token") , 
			   	'Accept' 		: 'application/json',
				'Content-Type' 	: 'application/json',
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({sample_number:response});
			}
		})

		fetch(Config.default.apiGateway.URL+'lookups?type=document_type&notrender=0',{
			method: 'get',
			headers: new Headers({
			   	'Authorization' : 'Bearer ' + sessionStorage.getItem("token") , 
			   	'Accept' 		: 'application/json',
				'Content-Type' 	: 'application/json',
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({documents:response});
			}
		})

		fetch(Config.default.apiGateway.URL+'lookups?type=CIVIL_STATUS&option=actives&order=false',{ 
		    method: 'get',
		    headers: new Headers({
		       	'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       	'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
		  	this.setState({
		      civil_status_array: response
		    });
		})

		//llamada a servicio de escolaridad
		fetch(Config.default.apiGateway.URL+'lookups?type=SCHOOLING&option=actives&order=false',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      scholarships: response
		    });
		})

		//llamada a servicio de ocupacion
		fetch(Config.default.apiGateway.URL+'lookups?type=profession&option=actives&order=false',{ 
		    method: 'get',
		    headers: new Headers({
		       	'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       	'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
		  	this.setState({
		      jobProfiles: response
		    });
		})

		fetch(Config.default.apiGateway.URL+'lookups_level2?type=state_mx&option=parents',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      states: response
		    });

		    this.props.waiting.handleClose();
		})

		if(this.props.match.params.id !== undefined){
			if(this.props.match.params.id !== '0'){
				var api = this.props.match.path.indexOf('second_samples') !== -1 ?
							'donors_second_sample/'+this.props.match.params.id
						: 'samples/show?id='+this.props.match.params.id;

				fetch(Config.default.apiGateway.URL+api, {
					method : 'get',
					headers: new Headers({
						'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
						'Accept' 		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				})
				.then(res => {
		            if(res.ok){
		              return res.json();
		            }else{
		              res.text().then(function(error) {
		                swal('¡Error!', error, 'error');
		              });
			        }
			    })
				.then(response =>{
					if(response !== undefined){
						this.props.match.path.indexOf('second_samples') !== -1 ?
							this.setSecondSample(response)
						:this.setValues(response);
					}
	        

		        })
			}else{
				this.setState({new_type: "sample"});
				this.getInfo(this.props.match.params.donor_id);
			}

				
		}
	}

	setValues(response){
		this.setState({new_type:'new'});
		this.calcularEdad(response.birthday, document.getElementById('birthday'));

        this.setState({
        	timestamp: response.timestamp,
        	convoke_places_id: response.convoke_places.id,
        	sample_id: response.sample_types.id,
        	sample_number: response.number,
        	birthday: response.birthday,
        	document_type: response.document !== null ? response.document.document_type : "",
        	document_number: response.document !== null ? response.document.document_number : "",
        	sex: response.person.sex,
        	civil_status: response.person.civil_status,
        	names: response.person.names,
        	lastname1: response.person.lastname1,
        	lastname2: response.person.lastname2,
        	email: response.person.email,
        	scholarship: response.person.scholarship,
        	job_profile: response.person.job_profile,
        	street: response.address.street,
        	postal_code: response.address.postal_code,
        	table_analitical: response.analitical_test,
        	donor_id: response.donor_id,
        	person_donor_id: response.person.id,
        	address_id: response.address.id,
        	disableFields:true,
        	lookup_group: response.person.lookup_group,
        	lookup_rh: response.person.lookup_rh,

        });
        this.getMpios(response.address.estado, response.address.municipio);

        this.setJobProfile(response.person.job_profile);
	}

	setSecondSample(response){
		this.setState({new_type:'sample', edition:true});
		var birth = moment(response.donor_data.person.birthday).format('DD/MM/YYYY');
		
		this.calcularEdad(birth, document.getElementById('birthday'));

        this.setState({
        	sample_id: response.second_sample.samples_id,
        	birthday: birth,
        	document_type: response.donor_data.document !== null ? response.donor_data.document.document.document_type : "",
        	document_number: response.donor_data.document !== null ? response.donor_data.document.document.document_number : "",
        	sex: response.donor_data.person.sex,
        	civil_status: response.donor_data.person.civil_status,
        	names: response.donor_data.person.names,
        	lastname1: response.donor_data.person.lastname1,
        	lastname2: response.donor_data.person.lastname2,
        	email: response.donor_data.person.email,
        	scholarship: response.donor_data.person.scholarship,
        	job_profile: response.donor_data.person.job_profile,
        	street: response.donor_data.address.street,
        	postal_code: response.donor_data.address.postal_code,
        	//table_analitical: response.analitical_test,
        	donor_id: response.donor_data.donor.id,
        	person_donor_id: response.donor_data.person.id,
        	address_id: response.donor_data.address.id,
        	disableFields:true,
        	lookup_group: response.donor_data.person.lookup_group,
        	lookup_rh: response.donor_data.person.lookup_rh,

        	total_hc:response.donor_data.total_hc,
			status_bar_color:response.donor_data.status_bar_color,
			temporality:response.donor_data.temporality,
			photo:response.donor_data.person.photo,
			donor_number:response.donor_data.donor.donor_number,
			phonesAdded:response.donor_data.phones,
			total_donations:response.donor_data.total_donations,
			donation_selected:{
				donation_number: response.second_sample.donation_number,
				date: moment(response.second_sample.date).format('DD/MM/YYYY'),
				check: false,
				color: '',
				extraction_type:response.second_sample.extraction_type,
				donation_type: response.second_sample.donation_type,
				pending_results: response.second_sample.pending_results,
				donation_id:response.second_sample.donation_id,
				extraction_lookup: response.second_sample.extraction_lookup,
				sample_id: response.second_sample.samples_id,
				offers_id: response.second_sample.offers_id,
				donation_notes_id:  response.second_sample.donation_notes === null ? 0 : response.second_sample.donation_notes.id
			},

        });
        this.getMpios(response.donor_data.address.estado, response.donor_data.address.municipio);

        this.setJobProfile(response.donor_data.person.job_profile);
        this.tool.setState({
			disableBar:false
		});
	}

	getTimeServer(){
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');

			var date = aux[0].split('/').reverse().join('-')
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				timestamp: aux[0]+' '+hours,
				time_date: date+' '+hours
			});
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleChange(e){
		var campo = e.target.name;
		var value = e.target.value;
		this.setState({
			[campo]: value
		});

		if(value !== ""){
			setTimeout(()=>{
				this.showCtrlError(campo);
			}, 500);
		}
	
		if(campo === "birthday"){
			var control = document.getElementById(e.target.id);
			if(e.target.value.length === 10 && e.target.value.indexOf('_') === -1){
				control.classList.remove('error');
		    	this.calcularEdad(e.target.value, control);
			}else{
				if(e.target.value === ""){
					control.classList.remove('error');
					this.setState({age: ""});
				}else{
					control.classList.add('error');
				}
			}
		}else if(campo === "blockFields"){
			if(e.target.checked){
				this.setState({disableFields:false});

			}else{
				this.setState({disableFields:true});
			}
		}else if(campo === 'sample_id'){
			var selected = e.target.selectedIndex;
			var id_analitical_profile = "";
			if(e.target.value === ""){
				this.setState({
					table_analitical:[]
				});
			}else{
				id_analitical_profile = parseInt(document.getElementById(campo).options[selected].getAttribute('data_key'));
				this.getAnaliticalProfile(id_analitical_profile);
			}	
		}else if(campo === 'new_type'){
			if(value === ""){
				this.clear(e);
			}
			
			if(value === 'sample'){
				this.setState({disableFields:true});
			}
		}else if(campo === 'email'){
			if(!isEmail(value)){
				this.setState({error_email: value !== "" ? 'Formato no valido' : ""});
			}else{
				this.setState({error_email: ''});
			}
		}
	}

	getPerson(){
		var person = {};
		var date = moment(this.state.birthday.split('/').reverse().join('-')).format('MM-DD-YYYY');
		person.lastname1 = this.state.lastname1;
		person.lastname2 = this.state.lastname2;
		person.names = this.state.names;
		person.birthday = date;
		person.sex = this.state.sex;
		person.civil_status = this.state.civil_status;
		person.person_type='donor';
		person.scholarship = this.state.scholarship;
		person.job_profile = this.state.job_profile;
		person.email = this.state.error_email !== "" ? "" : this.state.email;
		person.documents = [];
		person.address_id = this.state.address_id;
		person.lookup_group = this.state.lookup_group;
		person.lookup_rh = this.state.lookup_rh;
		
		if(this.state.document_type !== ""){
			var obj = {}
			obj.document_type = this.state.document_type;
			obj.document_number = this.state.document_number;
			person.documents.push(obj);
		}

		person.address = this.getAddress();

		if(this.state.person_donor_id !== ""){
			person.id = this.state.person_donor_id;
		}

		return person;
	}

	getAddress(){
		var address = {};
		address.street = this.state.street;
		address.postal_code = this.state.postal_code;
		address.municipio = this.state.mpio;
		address.estado = this.state.state;
		if(this.state.address_id!==""){
			address.id = this.state.address_id;
		}

		return address;
	}

	onSave(){
		if(this.validBirthdate()){
			if(this.isValidForm()){
				if (this.isValidaDate(this.state.birthday)){
					var obj = {};
					var timestamp = moment(this.state.time_date, 'YYYY-MM-DD H:mm');
					var api = "";
					var method = "";

					if(this.state.new_type === 'new'){
						obj.sample = {
							convoke_places_id: parseInt(this.state.convoke_places_id, 10),
							timestamp: timestamp.format('MM-DD-YYYY H:mm'),
							sample_types_id: parseInt(this.state.sample_id, 10)
						};
						obj.person = this.getPerson();

						var donor = this.state.donor_id !== "" ? this.state.donor_id : 0;
					
						/*if(this.state.error_email !== ""){
							swal('Error', 'Correo electrónico no tiene un formato correcto', 'error');

							return false;
						}*/

						if(this.props.match.params.id !== undefined && this.state.new_type === 'sample'){							
							api = 'samples/update_sample?donor_id='+donor;
							method = 'PUT';

							obj.sample.id = parseInt(this.props.match.params.id, 10);
							obj.sample.number = parseInt(this.state.sample_number, 10);
						}else{
							api = 'samples/create_sample?health_facilities_id='+
									sessionStorage.getItem('health_facilities_id')+'&donor_id='+donor;
							method = 'POST';
						}
					}else{
						obj.samples_id = this.state.donation_selected.sample_id;
						obj.health_facilities_id = parseInt(sessionStorage.getItem('health_facilities_id'), 10);
						obj.donors_second_sample_test = [];

						if(this.state.donation_selected.pending_results !== undefined){
							this.state.donation_selected.pending_results.map((don)=>{
								return obj.donors_second_sample_test.push({
									analitical_test_id: don.analitical_test_id
								})
							});


						}else{
							swal('Error', 'No es posible guardar el registro, no ha seleccionado ninguna donación', 'error');
							return false;
						}

						api = 'donors_second_sample';
						method = 'POST';
							
					}					
					
					

					this.props.waiting.handleShow('Guardando...');
					fetch(Config.default.apiGateway.URL+api, {
						method:method,
						body: JSON.stringify(obj),
						headers: new Headers({
							'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
							'Accept'		: 'application/json',
							'Content-Type'	: 'application/json'
						})
					}).then(res =>{
						this.props.waiting.handleClose();
						if(res.ok){
							return res.json();
						}else{
							res.text().then((msg)=>{
								swal('Error', msg, 'error');
							});
						}
					}).then(response => {
						if(response !== undefined){
							//Imprimir Etiqueta para muestras
							//var sample_id = response.sample !== undefined ? response.sample.id : response.samples_id
							//this.printSampleLabel(sample_id);
							this.setState({show_finish:true});
							swal('Correcto', 'Registro guardado correctamente', 'success');
							//this.props.history.push('/samples');
						}
					})

				}else{
					notify.show('Error, Fecha no válida','error');
				}
			}else{
				swal('Error', 'Campos Incompletos', 'error');
			}
		}else{
			swal('Error', 'La Fecha de Nacimiento no puede ser mayor a la fecha de hoy', 'error');
		}
			
	}

	validBirthdate(){
		var aux_date = new Date();
		var hoy = aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2);
		hoy = moment(hoy);
		var birth = moment(this.state.birthday,'DD-MM-YYYY');
		var date_ok = true;

		if(hoy !== 'Invalid date' && birth !== 'Invalid date'){
			if(hoy < birth){
				date_ok = false;
			}
		}else{
			date_ok = false;
		}		

		return date_ok;

	}

	isValidaDate(fecha){
		var arr = fecha.toString().split("/");
		for(var i=0; i< arr.length;i++){
			if (!/^([0-9])*$/.test(arr[i]))
				return false;
		}
		var fecha_aux = new Date(fecha.split(/\//).reverse().join('/'));
		if(fecha_aux.toString() === 'Invalid Date')
			return false;
		
		return true;
	}

	printSampleLabel(id){
		fetch(Config.default.apiGateway.URL+'html_templates?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+'&file_type=label_samples&extraction_type=',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
			if(res.ok){
			  return res.json();
			}else{
			  res.text().then(function(result) {
				swal('¡Error', result, 'error');
			  });
			}})
		.then(response => {
			if(response.res === 0){
				swal('¡Error!', "No se ha definido ninguna etiqueta para el \"Registro de Muestras\"", 'error');
				this.props.history.push('/samples');
			}else{
				this.waiting_modal.handleShow('Imprimiendo...');

				var obj ={};
				obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
				obj.id = id;
				obj.file_type = "label_samples";
				obj.nEtiqueta = [0];

				fetch(Config.default.apiGateway.URL+"labelsEditor", {
					method : 'post',
					body:JSON.stringify(obj),
					responseType: 'blob', //Force to receive data in a Blob Format
					headers : new Headers({
						'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
						'Content-Type': 'application/json'
					})
				})
				.then(res => {
					this.waiting_modal.handleClose();
					if(res.ok){
						return res.blob();
					}else{
					  res.text().then(function(result) {
						swal('¡Error!', result, 'error');
						
						return;
					  });
					}
				})
				.then(response => {
					if(response !== undefined){
						if(this.state.preview_print.value === "NO"){
							//PREVIEW
							var fileURL = URL.createObjectURL(response);
							window.open(fileURL);
						}else{
							//PRINTER
							var reader = new FileReader();
							reader.readAsDataURL(response); 
							reader.onloadend = ()=> {
								var base64data = reader.result;  
								var aux = base64data.split(',');
								this.props.socket.send('{"Operacion":"print", "Type":"extractions", "File": "'+aux[1]+'"}');
							}
						}
						this.setState({ show: false});
						this.props.history.push('/samples');
					}
				})
			}
		});
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
    			const isInputValid = this.showCtrlError(input.name);
    			
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
	    			   
		  	}
	    });
	    
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		
		if(control !== null){
			if(this.state[refName] !== undefined){
				if(this.state[refName] === ""){
					control.classList.add('error');
					res = false
				}else{
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
					}
					res = true;
				}
			}else{
				if(control.value === ""){
					control.classList.add('error');
					res = false
				}else{
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
					}
					res = true;
				}
			}
		}

		return res;
	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined)
      			if(form.elements[index + 1].name === ""){
      				form.elements[index + 2].focus();
      			}else{
      				form.elements[index + 1].focus();
      			}
    			
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	addTest(){
  		var index = this.state.table_analitical.findIndex(obj => obj.id === parseInt(this.state.analitical_id));

  		if(index === -1){
  			this.state.analitical_list.map((item)=>{
  				return item.analitical_test.id === parseInt(this.state.analitical_id, 10) ?
  					this.setState({
			  			table_analitical: [
			  				...this.state.table_analitical, 
			  				{
			  					id: item.analitical_test.id,
			  					name: item.analitical_test.name,
			  					type: item.analitical_test.type,
			  					settled: item.settled_text_at
			  				}
			  			],
			  			analitical_id:"",
			  		})
  				: null
  			})	
  		}else{
			swal('Error', 'La prueba ya se encuentra en la tabla', 'error');
  		}
  	}

  	addToList(id){
  		var table = []
  		var list = this.state.profile_list.analytical_test_has_analytic_profile_donors;
  	
		list.map((item)=>{
			var index = this.state.analitical_list.findIndex(obj =>
				obj.analitical_test.id === item.analitical_test_id
			)
			var obj = {};  				
			obj.id = this.state.analitical_list[index].analitical_test.id;
			obj.name = this.state.analitical_list[index].analitical_test.name;
			obj.type = this.state.analitical_list[index].analitical_test.type;
			obj.settled = this.state.analitical_list[index].settled_text_at;

			return table.push(obj); 
		});

  		this.setState({
  			table_analitical: table
  		});
  	}

  	calcularEdad(fecha, control){
		var hoy = new Date();
	    var cumpleanos = new Date(fecha.split(/\//).reverse().join('/'));
	    if(cumpleanos.toString() !== 'Invalid Date'){
		    var edad = hoy.getFullYear() - cumpleanos.getFullYear();
		    var m = hoy.getMonth() - cumpleanos.getMonth();

		    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
		        edad--;
		    }
		    if(edad >= 0 && edad < 110){
		    	this.setState({age:edad});	
		    }else{
		    	this.setState({age:'', birthday:''});	
		    	swal('Error', 'Fecha de nacimiento incorrecta', 'error');
		    }
		}else{
			/*control.classList.add('error');
			notify.show('Error, Fecha no válida','error');*/
		}
	}

	_handleSearchDonor = (query) => {

	    this.setState({
	    	isLoading: true,
	    	total_hc:"",
			status_bar_color:"",
			temporality:"",
			photo:"",
			donor_number:"",
			phonesAdded:[],
			total_donations:0,
			donation_selected:{},
			day_sesion_donation:"",
			optionsDonor:[],
			document_type:"",
			document_number:"",
			sex:"",
			civil_status:"",
			birthday:"",
			age:"",
			names:"",
			lastname1:"",
			lastname2:"",
			email:"",
			scholarship:"",
			job_profile:"",
			street:"",
			postal_code:"",
			state:"",
			person_donor_id:"",
			address_id:"",
			donor_id:"",
			indice:"",
			mpioSelected:[],
			mpio:"",
		});

		fetch(Config.default.apiGateway.URL+'donors?search='+query,{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			if(response !== null){
				for (var i = 0; i < response.length; i++) {
					/* revisar en la base de datos el lastname1 y lastname2 ya que lastname1 contiene el lastname2*/
					response[i].name = response[i].names;
					if(response[i].lastname2 !== undefined && response[i].lastname2 !== null && response[i].lastname2 !== ""){
						response[i].names = response[i].lastname1 +' '+ response[i].lastname2+' '+response[i].names +' '+ response[i].birthday;;
					
					}else{
						response[i].names = response[i].lastname1 +' '+ response[i].names +' '+ response[i].birthday;;
					}
					if(response[i].document !== null){							
						response[i].names +=' '+response[i].document_type_value;
						response[i].names +=' '+response[i].document_number;
					}
					response[i].id = response[i].donor_id;
				};
				
				this.setState({
					isLoading: false,
					optionsDonor: response,

					
				});
			}
		})
	}

	_handleSearch = (query) => {
		
	    this.setState({isLoading: true, mpioSelected:[]});

		fetch(Config.default.apiGateway.URL+'lookups_level2?type='+query+'&option=municipios',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			for (var i = 0; i < response.length; i++) {
				response[i].names = response[i].municpio.value_name +', '+response[i].estado.value_name;
				response[i].id = i;
			};
			this.setState({
				isLoading: false,
		      	options: response
		    });

		    if (response.length > 1) {
		    	this.setState({
					indice:-1
			    });
		    }else {
		    	this.setState({mpioSelected:response})
		    };
		})
	}

	clear(e){
		if(e !== undefined)
			e.preventDefault();
		//this.refs._handleSearchDonor._instance.instanceRef.clear();
		this.setState({
			day_sesion_donation:"",
			optionsDonor:[],
			document_type:"",
			document_number:"",
			sex:"",
			civil_status:"",
			birthday:"",
			age:"",
			names:"",
			lastname1:"",
			lastname2:"",
			email:"",
			scholarship:"",
			job_profile:"",
			street:"",
			postal_code:"",
			state:"",
			person_donor_id:"",
			address_id:"",
			donor_id:"",
			donor_number:"",
			indice:"",
			mpioSelected:"",
			mpio:"",

			isLoading: false,
			//time_date:"",
			disableFields:false,
			total_hc:"",
			status_bar_color:"",
			temporality:"",
			photo:"",
			phonesAdded:[],
			total_donations:0,
			donation_selected:{},
			error_email:""
		});


		if(this.state.new_type === 'sample'){
			this.tool.setState({
				disableBar:true
			});
		}
			
	}

	updateStateDonor(values) {
	    if (values.length > 0) {
	    	this.refs._handleSearchDonor._instance.getInstance().clear();

	    	if(values[0].document_type_value !== ""){
	    		var index = this.state.documents.findIndex(obj => 
	    			obj.key.indexOf(values[0].document_type_value) !== -1
	    		);

		    	if(index !== -1){
		    		var doc = this.state.documents[index].key;
		    	}
	    	}

			this.setState({
				optionsDonor:[],
				id_donor: values[0].donor_id,
				name:values[0].name,
				apPaterno:values[0].lastname1,
				apMaterno:values[0].lastname2,
				f_nacimiento: values[0].birthday,
				document_type: doc !== undefined ? doc : "",
				document_number: values[0].document_number ,
				social_number:"",
				disableFields:true,

			});  

			this.getInfo(values[0].donor_id);
	    }
	}

	updateState = (values,index) =>{
		if(values!== undefined){
			if(values.length>0){
				this.setState({
					mpio: values[0].municpio.key,
					state: values[0].estado.key,
					indice:values[0].id,
					mpioSelected:values
				});
			}
		}
	};

	getInfo(id){
		fetch(Config.default.apiGateway.URL+'donors?option=loadDonor&donor_id='+id,{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then((response) => {
			if(response !== "" && response !== null){
				this.setInfoDonor(response);

				this.props.waiting.handleClose();
			}
		})
	}

	setInfoDonor(item){
		if(item !== "" && item !== null && item!== undefined){			
			var aux_date = new Date(item.person.birthday);
			var string_date = ("0" + aux_date.getDate()).slice(-2)+'/'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'/'+aux_date.getFullYear();

			this.setState({
				names:item.person.names,
				lastname1:item.person.lastname1,
				lastname2:item.person.lastname2!==null?item.person.lastname2:"",
				sex:item.person.sex,
				civil_status:item.person.civil_status,
				scholarship:item.person.scholarship,
				job_profile:item.person.job_profile,
				email:item.person.email,
				birthday:string_date,
				street:item.address.street,
				postal_code:item.address.postal_code,
				mpio:item.address.municipio,
				state:item.address.estado,
				person_donor_id:item.person.id,
				address_id:item.address.id,
				donor_id:item.donor.id,
				donor_number:item.donor.donor_number,
				lookup_group:item.person.lookup_group,
				lookup_rh: item.person.lookup_rh,

				total_hc:item.total_hc,
				status_bar_color:item.status_bar_color,
				temporality:item.temporality,
				photo:item.person.photo,
				phonesAdded:item.phones,
				total_donations:item.total_donations,
			});
			if(item.document.document !== null){
				this.setState({
					document_type:item.document.document.document_type,
					document_number:item.document.document.document_number
				});
			}
			this.calcularEdad(string_date,'birthday');
			this.getMpios(item.address.estado,item.address.municipio);

			this.setJobProfile(this.state.job_profile);

			if(item.alerts.length > 0){
				var alerts = "";
				item.alerts.map((n)=>{
					var note = htmlToText(n);
					alerts += note;
				})

				swal('Alerta', alerts, 'warning')
			}
		}
	}

	getMpios(key,mpio){
		if(mpio!=="" && mpio !== null){
			this.setState({
				indice:0,
				mpio:mpio,
				state:key
			});
			this._handleSearch((mpio.replace(/_/g, " ")).toLowerCase());
		}
	}

	getAnaliticalProfile(id){
		fetch(Config.default.apiGateway.URL+'analytic_profile_person/'+id, {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({profile_list:response});

				setTimeout(()=>{
					this.addToList(id);
				}, 500);
			}
		});
	}

	onReturn(){
		this.props.history.goBack();
		//this.props.history.push('/samples');
	}

	/*Bloque de codigo para el manejo del autocomplete de profesión*/
	_handleSearchJob = (query) => {
		//console.log(query)
	}

	handleTypeAheadChange = name => values => {
        if(values.length > 0){
        	this.setState({
				indice:0,
				requestedSelected:values,
				[name]:values[0].key,
		    });
        	//this.props.autocompleteHandle(name,values[0].key);
        	
        }
    }

    setJobProfile(profile){

    	for (var i = 0; i < this.state.jobProfiles.length; i++) {
				
			if (this.state.jobProfiles[i].key === profile) {
				this.setState({
					indice:i,
					requestedSelected: [this.state.jobProfiles[i]],
				});
				break;
			}
		}	
    }

    donationsModal(e){
    	e.preventDefault();

    	if(this.state.donor_id !== ""){
    		this.donations_modal.handleShow(this.state.donor_id);
    	}else{
    		swal('Error', 'Debe seleccionar un donador', 'error');
    	}
    	
    }

    updateNoteId(id){
    	this.state.donation_selected.donation_notes_id = id;
    	this.forceUpdate();
    
    }

    concatGroupRH(){
		var res = "";

		if(this.stale.lookup_rh==="POSITIVO"){
			res = this.state.lookup_group+'+'
		}else{
			res = this.state.lookup_group+'-';
		}
		if(res.length>0){
			if(this.state.group_test !== null){
				if(this.state.group_test.lectina !== null){
					var position = 1;
					res = [res.slice(0, position), this.state.group_test.lectina, res.slice(position)].join('');
				}
			}
		}


		return res;
	}

	setDonation(item){
		this.tool.setState({
			disableBar:false
		});
		this.setState({donation_selected:item});
	}

	person_search(){
		this.modal_person_search.handleShow('Donador','donors');
	}

	render(){
		const {t} = this.props;
		var session = sessionStorage.getItem('health_facilities_name');

		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.donors.MAIN')} ->
						{t('sidebar.nav.distribution.samples')}
					</h5>
				</div>
				<form noValidate>
					<div className={this.state.new_type === 'new' ? "col-xs-12 form-group" : "col-xs-12 col-sm-9"}>
					<div className="col-xs-12">
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Tipo</span>
							<select className="form-control" name="new_type" id="new_type" 
								value={this.state.new_type}
								disabled={this.state.edition}
								onChange={this.handleChange}>
								<option value="">Seleccione</option>
								<option value="new">NUEVO</option>
								<option value="sample">2ª MUESTRA</option>
							</select>
						</div>
						
					</div>

					<hr style={{width:"100%"}}/>
					

					{this.state.new_type === 'new' ?
						<fieldset className="col-xs-12">
							<legend>Datos Donación</legend>
							<div className="col-xs-12 col-sm-2" style={{paddingRight:"0px"}}>
								<span className="span-min">{t('content.offers.form.timestamp')}</span>
								<input className="form-control" name="timestamp" id="timestamp"
									value={this.state.timestamp || ""} onChange={ this.handleChange }
									onKeyPress={this.state.validateInput} disabled />
					 		</div>

					 		<div className="col-xs-12 col-sm-2">
					        	<span className="span-min">{t('content.offers.form.day_session')}</span>
								<select className="form-control" name="day_session_donation" id="day_session_donation"
									value={this.state.day_session_donation} onChange={ this.handleChange }
									onKeyPress={this.state.validateInput} disabled>
					            	{this.state.day_sessions.map(function(t) {
					                	return <option  key={t.id}value={t.id} >
					                		{t.type_value} 
					                	</option>;
					                })}
					            </select>
					        </div>

							<div className="col-xs-12 col-sm-4">
								<span className="span-min">{t('content.offers.form.convoke_place')}</span>
								<select className="form-control" name="convoke_places_id" id="convoke_places_id" 
									value={this.state.convoke_places_id} onChange={ this.handleChange }
									onKeyPress={this.validateInput}	required autoFocus={true}>
					              	<option value="">Seleccionar...</option>
					                {this.state.convoke_places.map(function(t) {
					                  	return <option key={t.convoke_places.id} value={t.convoke_places.id} >
					                  		{t.convoke_places.name} 
					                  	</option>;
					                })}
				              	</select>
					        </div>

							<div className="col-xs-12 col-sm-1" style={{paddingRight:"0px", width:"11%"}}>
								<span className="span-min">No. Muestra</span>
								<input className="form-control" name="sample_number" id="sample_number"
									value={this.state.sample_number || ""} disabled />
					 		</div>
					        
					        <div style={{padding:"0px"}}>
						        <div className="col-xs-7">
						 			<span className="span-min">{t('content.generics.buttons.search')}</span>
							        <AsyncTypeahead
							          /*{...this.state}*/
							          labelKey={(option) => `${option.names}`}
							          minLength={3}
							          maxLength={50}
							          name="patient"
							          id="patient"
							          onSearch={this._handleSearchDonor}
							          placeholder="Buscar por apellidos más nombre o número de documento..."
							          options={this.state.optionsDonor}
							          onChange={this.updateStateDonor}
							          ref="_handleSearchDonor"
							          isLoading={this.state.isLoading}
							          useCache={false}
							          paginationText="Mostrar mas resultados..."
							        />
								</div>

								<div className="col-xs-12 col-sm-1" style={{textAlign:'center', marginTop:'18px'}}>
									<SvgIcon icon={search} size={20} style={{cursor:'pointer'}} 
										onClick={this.person_search}/>
								</div>

						        <div className="col-xs-12 col-sm-4">
									<button style={{marginTop:"16px",marginLeft:"5px"}} type="button" className="btn btn-info button-min" onClick={(e)=>this.clear(e)}>
										NUEVO
									</button>
									
						        </div>
						    </div>
					        
				        </fieldset>
					: null}
					{this.state.new_type !== 'new' && this.state.new_type !== '' && !this.state.edition?
						<div style={{padding:"0px"}} className="col-xs-12">
					        <div className="col-xs-7">
					 			<span className="span-min">{t('content.generics.buttons.search')}</span>
						        <AsyncTypeahead
						          /*{...this.state}*/
						          labelKey={(option) => `${option.names}`}
						          minLength={3}
						          maxLength={50}
						          name="patient"
						          id="patient"
						          onSearch={this._handleSearchDonor}
						          placeholder="Buscar por apellidos más nombre o número de documento..."
						          options={this.state.optionsDonor}
						          onChange={this.updateStateDonor}
						          ref="_handleSearchDonor"
						          isLoading={this.state.isLoading}
						          useCache={false}
						          paginationText="Mostrar mas resultados..."
						        />
						 			
							</div>
							<div className="col-xs-12 col-sm-1" style={{textAlign:'center', marginTop:'18px'}}>
								<SvgIcon icon={search} size={20} style={{cursor:'pointer'}} 
									onClick={this.person_search}/>
							</div>
							{this.state.total_donations > 0 ?
								<div className="col-xs-1">
									<button tyoe="button" className="btn btn-info" style={{fontSize:"0.8em", marginTop:"16px"}}
										onClick={this.donationsModal}>
										DONACIONES
									</button>
								</div>
							:null}
								
					    </div>
					: null}
					{this.state.new_type !== '' ?
				        <fieldset className="col-xs-12 form-group">
							<legend>Datos del Donador</legend>
								{this.state.donor_id !== "" && this.state.new_type !== 'sample' ?
									<div className="col-xs-12">
										<input className="form-check-input" type="checkbox" name="blockFields" 
											onChange={this.handleChange} onKeyPress={this.validateInput} 
											style={{marginRight:'5px'}}
											/>
							        	<span className="span-min">Editar Datos</span>
								    </div>
							    :null}
								<div className="col-xs-12" style={{padding:"0px"}}>
									<div className="col-xs-12 col-sm-2" >
							 			<span className="span-min">{t('content.offers.form.document_type')}</span>
											
							            <select className="form-control" name="document_type" id="document_type"
							            	value={this.state.document_type} onChange={this.handleChange} 
							            	onKeyPress={this.validateInput} disabled={this.state.disableFields}
									        > 
									        <option value="" disabled>Seleccionar...</option>
							                {this.state.documents.map(function(t) {
								                return <option key={t.id}  value={t.key} >
								                	{t.name} 
								                </option>;
							                })}
						              	</select>

									</div>
									<div className="col-xs-12 col-sm-2" >
										<span className="span-min">{t('content.offers.form.number')}</span>
							        	<input className="form-control" name="document_number" id="document_number"  
											value={this.state.document_number} onChange={this.handleChange}
											onKeyPress={this.validateInput} disabled={this.state.disableFields}/>
									</div>
									<div className="col-xs-12 col-sm-2" >
										<span className="span-min">{t('content.offers.form.gender')}</span>
							            <select className="form-control" id="sex" required name="sex"
							            	value={this.state.sex} onChange={this.handleChange} 
							             	onKeyPress={this.validateInput} disabled={this.state.disableFields}> 
									        <option value="" disabled>Seleccionar...</option>
							                {genders.map(function(t) {
							                  return <option key={t}  value={t} >{t} </option>;
							                })}
						              	</select>
									</div>
									
									<div className=" col-xs-12 col-sm-2" >
										<span className="span-min">{t('content.offers.form.civil_status')}</span>
							            <select className="form-control" name="civil_status" id="civil_status" 
											value={this.state.civil_status} onChange={this.handleChange} 
									        onKeyPress={this.validateInput} disabled={this.state.disableFields}> 
									        <option value="" disabled>Seleccionar...</option>
							                {this.state.civil_status_array.map(function(t) {
							                  	return <option key={t.id}  value={t.key} >
							                  		{t.name} 
							                  	</option>;
							                })}
						              	</select>
							        </div>

									<div className=" col-xs-12 col-sm-4" style={{paddingLeft: 0}}>
										<div className="form-group col-xs-12 col-sm-8" style={{marginBottom: 0}}>
											<span className="span-min">{t('content.offers.form.birthday')}</span>
											<MaskedFormControl type='text' className="form-control input-date" name="birthday" id="birthday" 
												value={this.state.birthday} onChange={this.handleChange}
		                          				onKeyPress={this.validateInput} disabled={this.state.disableFields}
		                          				mask='11/11/1111' placeholder="dd/mm/yyyy" required/>
										</div>
										<div className="form-group col-xs-12 col-sm-4" style={{paddingRight: 0,marginBottom: 0}}>
											<span className="span-min">{t('content.offers.form.age')}</span>
											<input className="form-control" name="age" id="age"
												value={this.state.age} onChange={this.handleChange}
												onKeyPress={this.validateInput} disabled/>
										</div>
									</div>
								</div>

								<div className="col-md-12" style={{padding:"0px"}}>
									<div className=" col-xs-12 col-sm-4" >
										<span className="span-min">{t('content.offers.form.names')}</span>
										<input className="form-control" id="names" name="names" 
											value={this.state.names} onChange={this.handleChange}
											onKeyPress={this.validateInput} disabled={this.state.disableFields} required/>
									</div>

									<div className="col-xs-12 col-sm-2">
							 			<span className="span-min">{t('content.offers.form.lastname1')}</span>
										<input className="form-control" name="lastname1" id="lastname1" 
											value={this.state.lastname1} onChange={this.handleChange}
											onKeyPress={this.validateInput} disabled={this.state.disableFields}  
											required/>
									</div>

									<div className="col-xs-12 col-sm-2" >
							 			<span className="span-min">{t('content.offers.form.lastname2')}</span>
										<input className="form-control" name="lastname2" id="lastname2" 
											value={this.state.lastname2} onChange={this.handleChange}
											onKeyPress={this.validateInput} disabled={this.state.disableFields} />
									</div>

									<div className="col-xs-12 col-sm-4" >
								        <span className="span-min">{t('content.offers.form.email')} </span>
								        <span className="span-min" style={{color:'red'}}>{this.state.error_email}</span>
						            	<input className="form-control" id="email" name="email" 
						            		placeholder="nombre@example.com"
						            		value={this.state.email} onChange={this.handleChange}
											onKeyPress={this.validateInput} disabled={this.state.disableFields}/>
									</div>

									<div className="col-xs-12 col-sm-4" >
								        <span className="span-min">{t('content.offers.form.scholarship')} </span>
						            	<select className="form-control" name="scholarship" id="scholarship"
								        	value={this.state.scholarship} onChange={this.handleChange}
								        	onKeyPress={this.validateInput} disabled={this.state.disableFields} >
								        	<option value="" disabled>Seleccionar...</option>
							                {this.state.scholarships.map(function(t) {
						                  		return <option  key={t.id}  value={t.key} >
						                  			{t.name}
						                  		</option>;
						                	})}
							            </select>
									</div>
									<div className="col-xs-12 col-sm-4" >
							        	<span className="span-min">{t('content.offers.form.job_profile')}</span>
							      
						              	<AsyncTypeahead 
								          /*{...this.state}*/
								          labelKey={(option) => `${option.name}`}
								          minLength={0}
								          id="job_profile" name="job_profile"
								          onKeyPress={(e) => this.props.validate(e)}
								          options={this.state.jobProfiles}
								          onChange={this.handleTypeAheadChange('job_profile')}
								          onSearch={this._handleSearchJob}
								          defaultSelected={this.state.jobProfiles.slice(this.state.indice, 1)}
									      selected={this.state.requestedSelected}
								          ref="_handleSearch"
								          disabled={this.state.disableFields}
								          isLoading={this.state.isLoading}
								          delay={600}
								          paginationText="Mostrar mas resultados..."
								    	/>
									</div>
								</div>

								<div className="col-xs-12" style={{padding:"0px"}}>
									<div className="col-xs-12" style={{padding:"0px"}}>
										<div className="col-xs-12" >
									 		<span className="span-min">{t('content.generics.address.street')}</span>
								        	<input type="text" className="form-control" name="street" id="street"  
								        		value={this.state.street} onChange={this.handleChange}
								        		onKeyPress={this.validateInput} disabled={this.state.disableFields}/>
										</div>
									</div>
									<div className="col-xs-12" style={{padding:"0px"}}>
										<div className="col-xs-12 col-sm-4" >
									 		<span className="span-min">{t('content.generics.address.postal_code')}</span>
								        	<input type="text" className="form-control" name="postal_code" id="postal_code"  
								        		value={this.state.postal_code} onChange={this.handleChange}
								        		onKeyPress={this.validateInput} maxLength="5" minLength="5" 
								        		disabled={this.state.disableFields}/>
										</div>

										<div className=" col-xs-12 col-sm-4" >
											<span className="span-min">{t('content.generics.address.mpio')}</span>
									        <AsyncTypeahead
									          /*{...this.state}*/
									          disabled={this.state.disableFields ? this.state.disableFields : false}
									          labelKey={(option) => `${option.names}`}
									          minLength={3}
									          name="mpio"
									          id="mpio" onKeyPress={this.validateInput}
									          onSearch={this._handleSearch}
									          options={this.state.options}
									          onChange={this.updateState.bind(this.props.index)}
									          defaultSelected={this.state.options.slice(this.state.indice, 1)}
									          selected={this.state.mpioSelected}
									          ref="_handleSearch"
									          isLoading={this.state.isLoading}
									          useCache={false}
									          delay={600}
									          paginationText="Mostrar mas resultados..."
									        />
								        </div>
									
								        <div className=" col-xs-12 col-sm-4" >
								            <div >
								            	<span className="span-min">{t('content.generics.address.state')} </span>
								            	<select className="form-control" name="state" id="state"
								            		value={this.state.state} onChange={this.handleChange}
										        	onKeyPress={this.validateInput} disabled={true} >
										        	<option value="" disabled></option>
									                {this.state.states.map(function(s) {
								                  		return <option key={s.id} value={s.key.toUpperCase()}>{s.value_name}</option>;
								                	})}
									            </select>
										    </div>
								        </div>
									</div>
									{this.state.new_type === 'new' ?
									<div className="col-xs-12" style={{padding:"0px"}}>
										<div className="col-xs-12 col-sm-2" style={{width:"21.8%"}}>
											<span className="span-min">Tipo de Muestra</span>
											<select className="form-control" name="sample_id" id="sample_id" 
												value={this.state.sample_id} onChange={this.handleChange} 
												onKeyPress={this.validateInput} required>
												<option value="">Seleccione...</option>
												{this.state.sample_list.map((list, i)=>{
													return <option key={i} data_key={list.analytic_profile_person_id} value={list.id}>
														{list.name}
													</option>
												})}
											</select>
										</div>
									</div>
									:null}
						      	</div>
						</fieldset>
					:null}
					{this.state.new_type === 'new' ?
						<fieldset className="col-xs-12 form-group">
							<legend>Pruebas Analíticas</legend>
							<div className="col-xs-12">
								
								<div className="col-xs-12">
									<Table responsive hover>
										<tbody>
											{this.state.table_analitical.map((list, i)=>{
												return (i+1 === 1) ?
													<tr key={i}>
														<td>{this.state.table_analitical[i]!== undefined ?
																this.state.table_analitical[i].name : ""}</td>
														<td>{this.state.table_analitical[i+1] !== undefined ?
																this.state.table_analitical[i+1].name : ""}</td>
														<td>{this.state.table_analitical[i+2] !== undefined ?
																this.state.table_analitical[i+2].name : ""}</td>
													</tr>
												: (i+1)%3 === 0 ?
													<tr key={i}>
														<td>{this.state.table_analitical[i+1] !== undefined ? this.state.table_analitical[i+1].name : ''}</td>
														<td>{this.state.table_analitical[i+2] !== undefined ? this.state.table_analitical[i+2].name : ''}</td>
														<td>{this.state.table_analitical[i+3] !== undefined ? this.state.table_analitical[i+3].name : ''}</td>
													</tr>
												:null
											})}
										</tbody>
									</Table>
								</div>
																
							</div>
						</fieldset>
					:null}

					</div>

					{this.state.new_type === 'sample' ?
						<div className="col-xs-12 col-sm-3">
							<div className="col-xs-12" style={{padding:"0px"}}>
				        		{this.state.total_hc !== 0?
				        		<div className="status-bar" style={{backgroundColor:this.state.status_bar_color,marginBottom:"5px", textAlign:"center"}} >
					            	<label style={{color:"white",margin:"3px"}}>{this.state.temporality}</label>
					            	
					            </div>:null}
				        		<div className="col-xs-12" style={{textAlign:"center",align:"center"}}>
				        		
				        		{/*this.state.lookup_group!=="" && this.state.lookup_group !== null?
									<div className="col-xs-12 col-sm-1" style={{padding:"0px"}}>
										<h2 style={{color:"red"}}>
											{this.concatGroupRH}
										</h2>
									</div>
								:null*/}
				        		{this.state.photo !== null?
				        			this.state.photo.length === 0 ?
				        				<img style={{height:'180px',width:'168px',textAlign:"center"}} src="../../default_user.jpg" alt="USER"/>
				        				
				        			:<img style={{height:'180px',width:'168px',textAlign:"center"}} src={'data:image/jpeg;base64,'+this.state.photo} alt="default"/>	
				        		:<img style={{height:'180px',width:'168px',textAlign:"center"}} src="../../default_user.jpg" alt="USER"/>}
					        	</div>

					        	<div className="col-xs-12" style={{padding:"0px",textAlign:"center"}}>

					        		<span className="col-xs-12 span-min">{t('content.offers.form.donor_number')}</span>
					        	
					        		<div className="col-xs-offset-4 col-xs-4" style={{padding:"0px"}}>
					        			<input name="donor_number" id="donor_number" value={ this.state.donor_number } 
						 					type="number" min="1" className="form-control" onChange={this.handleChange} 
						 					disabled={this.state.disableFields}/>
									</div>
								</div>
								
				        	</div>

				            <div className="col-xs-12"> 
				              <Table responsive hover style={{margin:"0px"}}>
				                <thead>
				                  <tr>
				                    <th>{t('content.generics.phones.type')}</th>
				                    <th>{t('content.offers.form.number')}</th>
				                    <th>{t('content.generics.phones.ext')}</th>
				                  </tr>
				                </thead>
				                <tbody>
				                 {this.state.phonesAdded.map( (phone, index) => (
				                    <tr key={index}>
				                      <td>{phone.type}</td>
				                      <td>{phone.number}</td>
				                      <td>{phone.extension}</td>
				                    </tr>
				                    ))}
				                </tbody>
				              </Table>
				            </div>
						</div>
					:null}

					{this.state.donation_selected.donation_number !== undefined ?
						<div className="col-xs-12 form-group">
							<fieldset className="col-xs-12 col-sm-6">
								<legend>Datos de Donación</legend>
								<div className="col-xs-12 form-group" style={{marginTop:"5px"}}>
									<div className="col-xs-12 col-sm-2">
										<span className="span-min">No. Donación</span>
									</div>
									<div className="col-xs-12 col-sm-8">
										<input className="form-control" disabled
											value={this.state.donation_selected.donation_number} />
									</div>
								</div>
								<div className="col-xs-12 form-group">
									<div className="col-xs-12 col-sm-2">
										<span className="span-min">Fecha</span>
									</div>
									<div className="col-xs-12 col-sm-8">
										<input className="form-control" disabled
											value={this.state.donation_selected.date} />
									</div>
								</div>
								<div className="col-xs-12 form-group">
									<div className="col-xs-12 col-sm-2">
										<span className="span-min">Tipo Extracción</span>
									</div>
									<div className="col-xs-12 col-sm-8">
										<input className="form-control" disabled 
											value={this.state.donation_selected.extraction_type}/>
									</div>
								</div>
								<div className="col-xs-12 form-group">
									<div className="col-xs-12 col-sm-2">
										<span className="span-min">Tipo Donación</span>
									</div>
									<div className="col-xs-12 col-sm-8">
										<input className="form-control" disabled 
											value={this.state.donation_selected.donation_type} />
									</div>
								</div>
							</fieldset>

							<fieldset className="col-xs-12 col-sm-6">
								<legend>Pruebas para Segunda Muestra</legend>
								<div className="col-xs-12" style={{marginTop:"5px"}}>
									<Table hover>
				        				<thead>
				        					<tr>
					        					<th>Prueba</th>
				        					</tr>
				        				</thead>
				        				<tbody>
				        					{this.state.donation_selected.pending_results !== undefined ? 
				        						this.state.donation_selected.pending_results.map((don, i)=>{
				        							return <tr key={i}>
				        								<td>{this.state.edition ? don.name.name : don.name}</td>
				        							</tr>
				        						})
				        					:null}
				        				</tbody>
				        			</Table>
								</div>
							</fieldset>
						</div>

					:null}

				
					{this.state.new_type === 'sample' ?
						<Toolbar {...this.props} state={this.state} onRef={ref => (this.tool = ref)} 
							history={this.props.history}
							updateNoteId={this.updateNoteId} />
					:null}
					
					{!this.state.show_finish?
						<div className="col-xs-12" style={{textAlign:'center'}}>
							{this.state.new_type !== '' && !this.state.edition ?
			        			<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave} style={{margin:12}}/>
			        		:null}
			        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} onClick={this.onReturn} style={{margin:12}} />
						</div>
					:<div className="col-xs-12" style={{textAlign:'center'}}>
						<RaisedButton className="action-btn" label={t('content.generics.buttons.finish')} primary={true} onClick={this.onReturn} style={{margin:12}} />
					</div>
					}

				</form>
				<Notifications />
				<DonationsModal setDonation={this.setDonation} {...this.props} onRef={ref => (this.donations_modal = ref)}/>
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
				<ModalPersonSearch {...this.props} waiting={this.props.waiting} updatePerson={this.updateStateDonor} onRef={ref => (this.modal_person_search = ref)} />
			</div>
		)
	}
}

export default translate('translations') (Samples);